import { useTranslation } from 'react-i18next'

import { Divider, FormatPrice, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ShippingCostInbound = ({ currency, total = 0, base = 0, additionalProducts = 0 }) => {
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <Styles.CostsContainer>
        <Styles.CostLine>
          <Text type="bodyMMedium">{t('Coste base')}</Text>
          <Text type="bodyMMedium">
            <FormatPrice currency={currency}>{base}</FormatPrice>
          </Text>
        </Styles.CostLine>
        <Styles.CostLine>
          <Text type="bodyMMedium">{t('Productos adicionales')}</Text>
          <Text type="bodyMMedium">
            <FormatPrice currency={currency}>{additionalProducts}</FormatPrice>
          </Text>
        </Styles.CostLine>
      </Styles.CostsContainer>
      <Divider />
      <Styles.CostLine>
        <Text type="bodyLBold">{t('Total envío')}</Text>
        <Text type="bodyLBold">
          <FormatPrice currency={currency}>{total}</FormatPrice>
        </Text>
      </Styles.CostLine>
    </Styles.MainContainer>
  )
}

export default ShippingCostInbound
